import { useEffect } from 'react';
import { AppThunk, useAppDispatch, useAppSelector } from '../../stores/redux-store';
import { findProviderByName } from '../../utilities/provider-utils';
import { fetchProvider } from '../../services/providers';
import { ProviderEntity } from '../../models/provider';

export type UseProviderArguments = {
  shouldFetch: boolean;
  providerName?: string;
};

export type UseProvider = (
  args: UseProviderArguments,
  fetchProviderAction?: FetchProviderActionCreator
) => ProviderEntity | undefined;

export type FetchProviderActionCreator = (providerName: string) => AppThunk;

export const useProvider: UseProvider = (
  { shouldFetch, providerName }: UseProviderArguments,
  fetchProviderAction: FetchProviderActionCreator = fetchProvider
) => {
  const providers = useAppSelector((s) => s.providers?.data);
  const dispatch = useAppDispatch();
  let provider;

  useEffect(() => {
    if (shouldFetch && !providers && providerName) {
      dispatch(fetchProviderAction(providerName));
    }
  }, [dispatch, providerName, shouldFetch, providers, fetchProviderAction]);

  if (providers && providerName) {
    provider = findProviderByName(providers, providerName);
  }

  return provider;
};
